import { render, staticRenderFns } from "./ResumoMensal.vue?vue&type=template&id=c554dd02&scoped=true&"
import script from "./ResumoMensal.vue?vue&type=script&lang=js&"
export * from "./ResumoMensal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c554dd02",
  null
  
)

export default component.exports